import * as Sentry from '@sentry/vue'

export interface PulsarState {
  organization?: string
  instance?: string
  clusterUid?: string
  workspaceUid?: string
  tenant?: string
  namespace?: string
  topic?: string
}

export interface PulsarStateRedirectRequest {
  e: unknown
  newDestination: PulsarState
}

const organization = ref<PulsarState['organization']>(undefined)
const instance = ref<PulsarState['instance']>(undefined)
const clusterUid = ref<PulsarState['clusterUid']>(undefined)
const workspaceUid = ref<PulsarState['workspaceUid']>(undefined)
const tenant = ref<PulsarState['tenant']>(undefined)
const namespace = ref<PulsarState['namespace']>(undefined)
const topic = ref<PulsarState['topic']>(undefined)

// TODO can we find a better way to handle these
//      scenarios? they're really just catch clauses
//      but should be initialized anyways by pulsarstate
//      and it's just weird that we have to keep these everywhere
//      when things should work from the router. i think this is
//      masking bugs
const mustOrganization = (): string => {
  if (organization.value) {
    return organization.value
  }
  throw Error('Organization is not set.')
}
const mustInstance = (): string => {
  if (instance.value) {
    return instance.value
  }
  throw Error('Instance is not set.')
}
const mustClusterUid = (): string => {
  if (clusterUid.value) {
    return clusterUid.value
  }
  throw Error('ClusterUid is not set.')
}
const mustWorkspaceUid = (): string => {
  if (workspaceUid.value) {
    return workspaceUid.value
  }
  throw Error('WorkspaceUid is not set.')
}
const mustTenant = (): string => {
  if (tenant.value) {
    return tenant.value
  }
  throw Error('tenant is not set.')
}
const mustNamespace = (): string => {
  if (namespace.value) {
    return namespace.value
  }
  throw Error('namespace is not set.')
}
const mustTopic = (): string => {
  if (topic.value) {
    return topic.value
  }
  throw Error('topic is not set.')
}
const sync = async (desiredState: PulsarState) => {
  const { setSelfSubjectUserReview } = useOrganization()
  try {
    // TODO this call can take 30 seconds cold, we should move this out somewhere else
    //      it also doesnt need to happen every single time
    await setSelfSubjectUserReview(true)
    organization.value = desiredState.organization
    instance.value = desiredState.instance
    clusterUid.value = desiredState.clusterUid
    workspaceUid.value = desiredState.workspaceUid
    tenant.value = desiredState.tenant
    namespace.value = desiredState.namespace
    topic.value = desiredState.topic
  } catch (e) {
    console.error('PulsarState Sync Error: ', e)
  } finally {
    Sentry.setContext('pulsar-state', {
      organization: organization.value,
      instance: instance.value,
      clusterUid: clusterUid.value,
      workspaceUid: workspaceUid.value,
      tenant: tenant.value,
      namespace: namespace.value,
      topic: topic.value
    })
  }
}

export const usePulsarState = () => {
  return {
    organization,
    mustOrganization,
    instance,
    mustInstance,
    clusterUid,
    mustClusterUid,
    workspaceUid,
    mustWorkspaceUid,
    tenant,
    mustTenant,
    namespace,
    mustNamespace,
    topic,
    mustTopic,
    sync
  }
}
